//FUNCIONS
import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../store/createStore';
import * as Yup from 'yup';

//HOOKS
import { useAccount } from '../../hooks/hooksAccount';
import { useTranslation } from '../../../../hooks/useTranslation';

//TYPES

//COMPONENTS

//STYLES
import { Container } from './styles';
import {
  Title,
  ContainerForm,
  FormLine,
  FormInputGroup,
  ContainerFooter,
  Button,
} from '../../styles';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { customerUpdateRequest } from '../../../../store/modules/auth/actions';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../../../components/Input';

interface CustomerProfile {
  email?: string;
  first_name?: string;
  last_name?: string;
  new_password?: string;
  new_password_confirmation?: string;
  gender?: string;
  date_of_birth?: string;
  customer_id?: string;
  customer_id_alt?: string;
  phone?: string;
}

const AccountDataPassword: React.FC = () => {
  const dispatch = useDispatch();
  const { setOpenViewPassword, openViewPassword } = useAccount()
  const { loading } = useSelector((state: StoreState) => state.auth);
  const {onTranslation : t} = useTranslation();
  const formRef = useRef<FormHandles>(null);

   const saveProfile = useCallback(
      async (customerDataProfile: CustomerProfile) => {
        try {
          const schema = Yup.object().shape({
              new_password: Yup.string()
                .required('Senha obrigatória')
                .min(6, 'No mínimo 6 digitos'),
              new_password_confirmation: Yup.string()
                .required('Senha obrigatória')
                .min(6, 'No mínimo 6 digitos')
                .oneOf([Yup.ref('new_password')], 'As senhas devem ser iguais'),
            });
  
          await schema.validate(customerDataProfile, {
            abortEarly: false,
          });
         
          if (
            customerDataProfile.customer_id &&
            customerDataProfile.customer_id.length > 0
          ) {
            const customer_id = customerDataProfile.customer_id
              .split('.')
              .join('')
              .replace(/\s_/g, '');
            customerDataProfile.customer_id = customer_id;
          }
  
          const customerProfile = {} as CustomerProfile;
          if (customerDataProfile.email)
            customerProfile.email = customerDataProfile.email;
          if (customerDataProfile.first_name)
            customerProfile.first_name = customerDataProfile.first_name;
          if (customerDataProfile.last_name)
            customerProfile.last_name = customerDataProfile.last_name;
          if (customerDataProfile.new_password)
            customerProfile.new_password = customerDataProfile.new_password;
          if (customerDataProfile.new_password_confirmation)
            customerProfile.new_password_confirmation =
              customerDataProfile.new_password_confirmation;
          if (customerDataProfile.gender)
            customerProfile.gender = customerDataProfile.gender;
          if (customerDataProfile.customer_id)
            customerProfile.customer_id = customerDataProfile.customer_id;
          if (customerDataProfile.phone)
            customerProfile.phone = customerDataProfile.phone;
  
          dispatch(customerUpdateRequest(customerProfile));
          formRef.current?.setErrors({});
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
              const errors = getValidationErrors(error);
              formRef.current?.setErrors(errors);
          }
        }
      },
      [dispatch],
    );

  return (
    <Container>
      <Title>
        <span>{t('main.new_account.account_data.change_my_password')}</span>
      </Title>
      <Form ref={formRef} onSubmit={saveProfile} autoComplete="off">
      <ContainerForm>
        <FormInputGroup>
          <FormLine width="100%">
             <Input
              type="password"
              name="new_password"
              textLabel="Nova Senha *"
              formRef={formRef}
              autoComplete="new-password"
            />
          </FormLine>
        </FormInputGroup>
        <FormInputGroup>
          <FormLine width="100%">
            <Input
              type="password"
              name="new_password_confirmation"
              textLabel="Confirmar Nova Senha *"
              formRef={formRef}
              autoComplete="new-password"
            />
          </FormLine>
        </FormInputGroup>
      </ContainerForm>
      <ContainerFooter >
        <Button typeStep='danger' onClick={() => setOpenViewPassword(!openViewPassword)}>
          <span>{t('main.globals.back')}</span>
        </Button>

        <Button type="submit" typeStep='success' active={loading}>
          <span>{t('main.globals.save')}</span>
        </Button>
      </ContainerFooter>
      </Form>
    </Container>
  );
}

export default AccountDataPassword;
